import { carsDesktopDevice, carsMobileDevice, mobilePhonesDesktopDevice, mobilePhonesMobileDevice } from './imageUrls';

export const ITEMS_SEARCH_SOURCE = 'search';
export const ITEMS_FEED_SOURCE = 'feed';
export const APIVERSION = { V1: 'v1', V2: 'v2', V3: 'v3', V4: 'v4' };
export const PUBLIC_PROFILE_ADS_LIMIT = 18;
export const GALLERY_MINIMUM_NO_OF_IMAGE_FOR_STICKY = 2;
export const GALLERY_IMAGE_MAX_HEIGHT_FOR_STICKY = 573;
export const GALLERY_IMAGE_MAX_WIDTH_FOR_STICKY = 430;
export const PUBLIC_DESKTOP_DEALER_PROFILE_ADS_LIMIT = 6;
export const PUBLIC_MOBILE_DEALER_PROFILE_ADS_LIMIT = 4;

export const RESERVE_WITH_TOKEN_EXP_CL = 'PAN-63990';

export const ORIGINAL_ITEMS = 'original';
export const SUGGESTED_ITEMS = 'suggested';

export const ITEM_SEARCH_RELAXATION_TYPE_BUCKET = 'bucket';
export const ITEM_SEARCH_RELAXATION_TYPE_POLYGON = 'polygon';
export const ITEM_SOURCE = {
    RELATED: 'related_ad',
    BUNDLE_LAST_SEARCH: 'bundle_last_search',
    BUNDLE_FAVOURITES: 'bundle_favourites',
    DIRECT: 'direct',
    OTHER: 'other_profile',
    FAVOURITES: 'my_favorites',
    SELLER_PROFILE: 'seller_profile',
    HOME: 'home',
    SEARCH: 'search',
    BROWSE: 'browse',
    MY_ADS: 'my_ads',
    RE_PROJECTS: 're_projects'
};

export const RESULTSET_TYPE = {
    RELATED: 'related_ads'
};

export const DYNAMIC_PANELS = {
    OVERVIEW: 'overview',
    ATTRIBUTES: 'attributes',
    SELLER: 'seller',
    MAP: 'map',
    INSPECTION_REPORT: 'inspection_report',
    FEATURES: 'features',
    DESCRIPTION: 'description',
    TECHNICAL_REPORT: 'technical_report',
    RELATED_ADS: 'related_ads',
    CONSUMER_FINANCING: 'consumer_financing',
    SWAP_CARS: 'swap_cars'
};

export const INSPECTION_INFO_STATUS = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REVOKED: 'REVOKED',
    CREATE_AD: 'CREATE_AD',
    INVOKED: 'INVOKED'
};

export const INSPECTION_AD_PREVIEW = 'inspection_details_to_ad_preview';
export const EXISTING_AD = 'inspection_details_to_existing_ad';
export const FILTER_INSPECTION_REPORT = true;

export const adpvAttributes = {
    LOCATION: 'location',
    INSPECTION_DATE: 'inspectionDate'
};

export const INSPECTION_TAB = {
    EXTERIOR: 'exterior',
    INTERIOR: 'interior',
    TYRES: 'tyres',
    DENT_MAP: 'dentMap'
};

export const CAR_MAP_COLOR = {
    SELECTED: '#FFDAB5',
    UNSELECTED: '#FFFFFF'
};

export const DENT_MAP_COLOR = {
    TRANSPARENT: '#00000000',
    SELECTED: '#F29B7C'
};

export const INSPECTION_TAP_FLOW_TYPE = {
    CAR_MAP: 'car_map',
    DENT_MAP: 'dent_map',
    CHIP: 'chip'
};

export const TECHNICAL_REPORT_SECTION_STATE = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
export const ITEM_FULL_SCREEN_HASH = 'item-gallery';
export const INSPECTION_FULL_SCREEN_HASH = 'inspection-gallery';

export const collapsedFeaturesLimit = {
    mobile: 8,
    desktop: 12
};

export const NAVBAR_ITEMS = {
    OVERVIEW: 0,
    INSPECTION_REPORT: 1,
    TECHNICAL_REPORT: 2,
    FEATURES: 3,
    CONSUMER_FINANCING: 4,
    SWAP_WIDGET: 5
};

export const HEADER_OFFSET = 144;
export const BREADCRUMB_HEIGHT = 40;
export const INSPECTION_DATE_ID = 'inspectionDate';

export const IS_TEMPORARY_AD = 'isTemporaryAd';

export const INSPECTION_INFO_GROUP = {
    CONSUMER: 'CONSUMER',
    INTERNAL: 'INTERNAL'
};

export const BREADCRUMB_SEPARATOR_SIZE = {
    desktop: 16,
    mobile: 12
};

export const USERFORM_STATES = {
    SHOW_INTEREST: 'show_interest',
    THANK_YOU: 'thank_you'
};

export const LEAD_GEN_SOURCES = {
    SHOW_INTEREST: 'show_interest',
    EXCHANGE_CAR: 'exchange_car',
    FINANCE: 'finance',
    NOTIFY_ME: 'notify_me',
    RESERVE: 'reserve'
};

export const LEAD_TYPE = {
    getStartedText: 'get_started',
    leadGenTxt: 'I_am_intersted',
    bookTestDrive: 'test_drive',
    requestCallBack: 'requestCallBack',
    reserveText: 'reserve_option',
    notifyText: 'notify_me'
};

export const FIELD_NAME = {
    MAKE: 'make',
    MODEL: 'model',
    NAME: 'name',
    EMAIL: 'email',
    PHONE: 'phone',
    SURNAME: 'lastname',
    MOTHER_MAIDEN_NAME: 'mother-maiden-name'
};

export const VAS_HASH = '#vas';
export const GALLERY_HASH = '#gallery';
export const LEAD_HASH = {
    NOTIFYME_HASH: '#notify'
};
export const MISSED_RESERVE_HASH = '#missed-reserve';
export const COMPARE_HASH = '#compare';

export const GALLERY_NAVIGATION_TILE_NAME = {
    EXTERIOR: 'exterior',
    INTERIOR: 'interior',
    DENT_MAP: 'dentMap',
    SELLER: 'seller',
    OTHER: 'other',
    SPIN_CAR: 'spinView'
};

export const GALLERY_NAVIGATION_TILES_DEFAULT_ORDER = [
    GALLERY_NAVIGATION_TILE_NAME.SPIN_CAR,
    GALLERY_NAVIGATION_TILE_NAME.EXTERIOR,
    GALLERY_NAVIGATION_TILE_NAME.INTERIOR,
    GALLERY_NAVIGATION_TILE_NAME.DENT_MAP,
    GALLERY_NAVIGATION_TILE_NAME.SELLER,
    GALLERY_NAVIGATION_TILE_NAME.OTHER
];

export const RESPONSIVE_SETTINGS = [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 1280,
        settings: {
            slidesToShow: 6,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 1440,
        settings: {
            slidesToShow: 7,
            slidesToScroll: 1
        }
    }
];

export const RESPONSIVE_THUMBNAILS_SETTINGS = [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 1280,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 1440,
        settings: {
            slidesToShow: 6,
            slidesToScroll: 1
        }
    }
];

export const ICONS = {
    ARROW_LEFT: 'arrowLeft',
    ARROW_RIGHT: 'arrowRight',
    ARROW_DOWN: 'arrowDown',
    CROSS: 'cross',
    FAV_OFF: 'favoriteOff',
    FAV_ON: 'favoriteOn',
    LINK: 'link',
    MAIL: 'mail',
    BACK: 'back',
    TICK_TRANSPARENT: 'tickTransparent',
    DOWNLOAD: 'download'
};

export const ICON_COLORS = {
    WHITE_ICONS: 'whiteIcons',
    WHITE: 'white',
    BLACK_DISABLED: 'blackDisabled',
    BLACK_TEXT: 'blackText',
    BLACK_SECONDARY_TEXT: 'blackSecondaryText',
    PRIMARY: 'primary',
    PRIMARY_BASE: 'primaryBase',
    BLACK: 'black',
    PRIMARY_LIGHT1: 'primaryLight1',
    MONITIZATION_DARK2: 'monetizationDark2',
    BLUEBASE: 'blueBase',
    BLACK_LIGHT3: 'blackLight3'
};

export const TYPE = {
    SUBTITLE: 'subtitle',
    BODY_1: 'body1',
    BODY_2: 'body2'
};

export const FONT_WEIGHTS = {
    BOLD: 'bold',
    NORMAL: 'normal'
};

export const TAG = {
    DIV: 'div'
};

export const ICONS_SIZE = {
    MEDIUM_ICONS: 20,
    SMALL_ICONS: 16
};

export const ENGINE_ID = 'enginePhoto';
export const EMI_EXPERIMENT = {
    olxcl: 'PAN-55262',
    olxmx: 'PAN-57265'
};

export const FCG_IMG_HEIGHT = {
    MOBILE: 240,
    DESKTOP: 480
};

export const FCG_TILE_IMG_HEIGHT = {
    MOBILE: 32,
    DESKTOP: 88
};

export const RESERVE_STATUS_TYPES = {
    RESERVED: 'RESERVED',
    AVAILABLE: 'AVAILABLE'
};

export const NOTIFY_ME_LEAD_FORM = 'NOTIFY_ME_LEAD_FORM';
export const ME_INTERESTED_LEAD_FORM = 'ME_INTERESTED_LEAD_FORM';

export const WHATSAPP = {
    LINK: 'https://api.whatsapp.com/send?',
    MESSAGE: { id: 'whatsAppInterestText', defaultMessage: 'Me interesa este auto' },
    DESKTOP_ICON: 46
};

export const LQ_SHORTLIST_FEATURE = 'ROAD-60278';
export const FAVOURITE = 'Favourite';
export const FAVOURITES = 'favourites';
export const PUBLIC_PROFILE_ICONS = {
    MORE_VERTICAL: 'moreVertical',
    FOLLOWING_ACTIVE_PROFILE: 'followingActiveProfile',
    FOLLOWING_INACTIVE_PROFILE: 'followInactiveProfile',
    FOLLOWERS_ICON: 'followersIcon',
    LOCATION_PROFILE: 'locationProfile',
    LOCATION: 'location',
    TIME_PROFILE: 'timeProfile',
    CLOCK: 'clock',
    INFO_FILLED: 'infoFilled',
    MEMBERS: 'members',
    EDIT_PRIVATE_PROFILE: 'editPrivateProfile'
};

export const LOCATION_URL = 'https://www.google.com/maps/dir/?api=1&query=';

export const AD_PAGE = 'adpage';
export const PRICE_CARD_TAB_EXPERIMENT = 'ROAD-73327';
export const EMI_SELECTED_ADS = 'emi_selected_ads';
export const LIST_OF_CITIES = 'Jabodetabek, Banten, Jawa Barat, Jawa Tengah, Jawa Timur, Yogyakarta, Bali';

export const CATEGORY = {
    PROPERTIES: '3',
    JOBS: '4',
    CARS: '5',
    FASHION: '87',
    ELECTRONICS: '99',
    PETS: '103',
    SERVICES: '619',
    FURNITURE: '628',
    BOOKS: '767',
    MOBILES: '1411',
    BIKES: '2198',
    COMMERCIAL_VEHICLES: '2207'
};
export const defaultTextInterLinks = 'Used {value} in {location}';
export const itemParameters = [
    'constructionstatus',
    'furnished',
    'job_type',
    'make',
    'mileage',
    'model',
    'petrol',
    'rooms',
    'transmission',
    'type',
    'year'
];

export const itemInterlinks = {
    3: {
        id: '3',
        key: 'real-estate',
        name: 'Properties',
        price: 'Properties Under {price} in {location}',
        type: 'Used {type} in {location}',
        furnished: '{furnished} options in {location}',
        rooms: '{rooms} BHK Flats in {location}',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    4: {
        id: '4',
        key: 'jobs',
        name: 'Jobs',
        job_type: '{job_type} {category} Jobs in {location}',
        category: '{category} Jobs in {location}',
        parameters: ['job_type']
    },
    84: {
        id: '84',
        key: 'vehicles',
        name: 'Cars',
        model: 'Used {make} {model} Cars in {location}',
        make: 'Used {make} Cars in {location}',
        price: 'Used Cars Under {price} in {location}',
        locality: 'Used Cars in {locality} in {location}',
        petrol: 'Used {petrol} Cars in {location}',
        transmission: 'Used {transmission} Cars in {location}',
        parameters: [
            'locality',
            'make',
            'model',
            'petrol',
            'price',
            'transmission'
        ]
    },
    99: {
        id: '99',
        key: 'electronics-appliances',
        name: 'Electronics & Appliances',
        category: 'Used {category} in {location}',
        price: 'Used {category} Under {price} in {location}',
        parameters: ['category']
    },
    103: {
        id: '103',
        key: 'pets',
        name: 'Pets',
        category: 'More in {category} in {location}',
        parameters: ['type']
    },
    619: {
        id: '619',
        key: 'services',
        name: 'Services',
        category: 'More in Used {category} in {location}',
        parameters: ['type']
    },
    628: {
        id: '628',
        key: 'furniture',
        name: 'Furniture',
        category: 'Used {category} in {location}',
        price: 'Used {category} Under {price} in {location}',
        parameters: ['type', 'price']
    },
    767: {
        id: '767',
        key: 'books-sports-hobbies',
        name: 'Books, Sports & Hobbies',
        category: 'Used {category} in {location}',
        parameters: ['type']
    },
    1411: {
        id: '1411',
        key: 'mobiles',
        name: 'Mobiles',
        make: 'Used {make} {category} in {location}',
        price: 'Used {category} Under {price} in {location}',
        parameters: ['make', 'price']
    },
    1455: {
        id: '1455',
        key: 'tablets',
        name: 'Tablets',
        type: 'Used {type} Tablets in {location}',
        price: 'Used Tablets Under {price} in {location}',
        parameters: ['type', 'price']
    },
    2198: {
        id: '2198',
        key: 'bikes',
        name: 'Bikes',
        model: 'Used {make} {model} Bikes in {location}',
        make: 'Used {make} Bikes in {location}',
        price: 'Used {category} Under {price} in {location}',
        parameters: ['make', 'model', 'price']
    },
    2207: {
        id: '2207',
        key: 'other-vehicles',
        name: 'Commercial Vehicles & Spares',
        year: 'Used {category} {year} Onwards in {location}',
        mileage: 'Used {category} Below {mileage} in {location}',
        price: 'Used {category} Under {price} in {location}',
        parameters: ['mileage', 'price', 'year']
    },

    // L2 Level Categories
    1725: {
        id: '1725',
        key: 'sale-houses-apartments',
        name: 'For Sale: Houses & Apartments',
        price: 'Flats for Sale Under {price} in {location}',
        type: 'Used {type} in {location}',
        furnished: '{furnished} Flats for Sale in {location}',
        rooms: '{rooms} BHK Flats in {location} for Sale',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    1723: {
        id: '1723',
        key: 'rent-houses-apartments',
        name: 'For Rent: Houses & Apartments',
        price: 'Flats for Rent Under {price} in {location}',
        type: 'Used {type} in {location}',
        furnished: '{furnished} Flats for Rent in {location}',
        rooms: '{rooms} BHK Flats in {location} for Rent',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    1449: {
        id: '1449',
        key: 'pg-guest-houses',
        name: 'PG & Guest Houses',
        price: '{category} Under {price} in {location}',
        type: 'Used {type} in {location}',
        furnished: '{furnished} {category} in {location}',
        rooms: '{rooms} BHK Flats in {location}',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    1729: {
        id: '1729',
        key: 'land-plots',
        name: 'Lands & Plots',
        price: '{category} {type} Under {price} in {location}',
        type: '{category} {type} in {location}',
        furnished: '{furnished} {category} in {location}',
        rooms: '{rooms} BHK Flats in {location}',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    1731: {
        id: '1731',
        key: 'rent-shops-offices-commercial-space',
        name: 'For Rent: Shops & Offices',
        price: '{category} Under {price} in {location}',
        type: '{category} {type} in {location}',
        furnished: '{furnished} {category} in {location}',
        rooms: '{rooms} BHK Flats in {location}',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    },
    1733: {
        id: '1733',
        key: 'sale-shops-offices-commercial-space',
        name: 'For Sale: Shops & Offices',
        price: '{category} Under {price} in {location}',
        type: '{category} {type} in {location}',
        furnished: '{furnished} {category} in {location}',
        rooms: '{rooms} BHK Flats in {location}',
        constructionstatus: '{constructionstatus} Properties in {location}',
        parameters: ['constructionstatus', 'furnished', 'rooms', 'type', 'price']
    }
};

export const PARAMETERS_KEY_MAP = {
    mileage: 'kms_driven',
    petrol: 'fuel',
    first_owner: 'no_of_owners'
};

export const CARS_CATEGORY_PAGE_SIZE = 40;
export const SIMILAR_ADS_PAGE_SIZE = 80;
export const DECIMAL_RADIX = 10;

export const MIDDLE_AD_INDEX_ONE = 11;
export const MIDDLE_AD_INDEX_TWO = 22;
export const ITEM_INDEX_BREAK = 10;

export const SELL_BANNER_IMAGE = {
    mobile: {
        1453: mobilePhonesMobileDevice,
        84: carsMobileDevice
    },
    desktop: {
        1453: mobilePhonesDesktopDevice,
        84: carsDesktopDevice
    }
};
